import { createContext } from "react";

const CatTipoServiciosContext = createContext();

export default CatTipoServiciosContext;
